<template>
  <div class="newAddKS">
    <el-form :model="ExamForm" :rules="rules" ref="ExamForm">
      <el-form-item
        label="考生账号："
        :label-width="formLabelWidth"
        prop="userName"
      >
        <el-input
          :disabled="this.isEdit"
          v-model.trim="ExamForm.userName"
          maxlength="12"
          show-word-limit
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="考生姓名："
        :label-width="formLabelWidth"
        prop="realName"
      >
        <el-input
          v-model.trim="ExamForm.realName"
          maxlength="20"
          show-word-limit
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="科室："
        :label-width="formLabelWidth"
        prop="DepartmentName"
      >
        <!-- <div v-for="items in options_ks" :key="items.DepartmentID">
          <div>{{items.DepartmentID}}</div>
          <div>{{items.DepartmentName}}</div>
        </div> -->
        <el-select v-model="ExamForm.DepartmentName" placeholder="请选择科室">
          <el-option
            v-for="item in options_ks"
            :key="item.DepartmentID"
            :label="item.DepartmentName"
            :value="item.DepartmentName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="登录密码："
        :label-width="formLabelWidth"
        prop="pwd"
        v-if="!this.isEdit"
      >
        <el-input
          v-model.trim="ExamForm.pwd"
          autocomplete="off"
          show-password
        ></el-input>
      </el-form-item>
      <!-- 1.30 产品修改远程搜索 -->
      <el-form-item label="职称：" :label-width="formLabelWidth">
        <!-- <el-select v-model="ExamForm.PTitle" placeholder="请选择职称">
          <el-option
            v-for="item in options_zc"
            :key="item.pTitleID"
            :label="item.PTitle"
            :value="item.PTitle"
          >
          </el-option>
        </el-select> -->
        <el-autocomplete
          v-model="ExamForm.PTitle"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"
          placeholder="请输入职称"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="职位：" :label-width="formLabelWidth">
        <!-- <div v-for="items in options_zw" :key="items.PositionID">
          <div>{{items.PositionID}}</div>
          <div>{{items.Position}}</div>
        </div> -->
        <!-- <el-select v-model="ExamForm.Position" placeholder="请选择职位">
          <el-option
            v-for="item in options_zw"
            :key="item.PositionID"
            :label="item.Position"
            :value="item.Position"
          >
          </el-option>
        </el-select> -->
        <el-autocomplete
          v-model="ExamForm.Position"
          :fetch-suggestions="querySearchAsyncTwo"
          @select="handleSelectTwo"
          placeholder="请输入职称"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="出生年月：" :label-width="formLabelWidth">
        <div class="block">
          <el-date-picker
            v-model="ExamForm.Birthday"
            type="date"
            placeholder="请选择日期"
            format="yyyy年-MM月-dd日"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="入职日期：" :label-width="formLabelWidth">
        <div class="block">
          <el-date-picker
            v-model="ExamForm.JoinDate"
            type="date"
            placeholder="请选择日期"
            format="yyyy年-MM月-dd日"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <!-- 编辑且有人脸识别照片 -->
      <!-- <el-form-item :label-width="formLabelWidth" v-if="isEdit && faceImg">
        <div class="block">
          <el-image
            style="width: 100px; height: 100px"
            :src="faceImg"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel('ExamForm')">取 消</el-button>
      <el-button type="primary" @click="onSubmit('ExamForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
import {
  createStudent,
  getSectionList,
  getPTitleList,
  getPositionList,
  modifyStudentInfo,
} from "@/services/examManager.js";
import md5Utils from "js-md5";

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    faceImg: {
      type: String,
      default: "",
    },
    srcList:{
      default: "",
    },
    examId: {},
  },
  data() {
    // 校验是否为数字
    var validateIsNumber = (rule, value, callback, prefixMsg) => {
      if (!/^[1-9]\d*$|^$/.test(value)) {
        callback(new Error(prefixMsg + "只能为数字"));
      } else {
        callback();
      }
    };
    // 校验非空
    var validateIsNull = (rule, value, callback, prefixMsg) => {
      if (value instanceof Array) {
        value = value.join("");
      }
      if (value.split(" ").join("").length === 0) {
        callback(new Error(prefixMsg + "不能为空"));
      } else {
        callback();
      }
    };
    return {
      // 新增考生表单
      ExamForm: {
        userName: "",
        realName: "",
        pwd: "",
        PTitle: "",
        JobDate: "",
        Birthday: "",
        Position: "",
        DepartmentName: "",
        JoinDate: "",
      },
      timeout: null,
      // 科室
      options_ks: [],
      // 职称
      options_zc: [],
      // 职位
      options_zw: [],
      formLabelWidth: "120px",
      // 新增考生对象
      examAddObj: {},
      rules: {
        userName: [
          { required: true, message: "请输入考生账号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "考生账号");
            },
            trigger: "blur",
          },
          {
            min: 8,
            max: 12,
            message: "长度在 8 到 12 个字符",
            trigger: "blur",
          },
        ],
        realName: [
          { required: true, message: "请输入考生姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "考生姓名");
            },
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        DepartmentName: [
          { required: true, message: "请输入科室名称", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "科室名称");
            },
            trigger: "blur",
          },
        ],
        pwd: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "登录密码");
            },
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: "长度在 至少5 个字符，最多20 个字符",
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          //禁用当天之后不包括今天 date.getTime() > Date.now() - 24 * 60 * 60 * 1000
          //禁用当天之前不包括今天 date.getTime() > Date.now()
          return date.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    // 取消
    onCancel(formName) {
      // 设置取消状态，让父组件处理
      this.$emit("cancel");
      this.$refs[formName].resetFields();
      this.ExamForm = {};
    },
    // 添加考生表单提交
    onSubmit(formName) {
      // 新增的时候
      if (!this.isEdit) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addExamData();
          } else {
            console.log("check error submit!!");
            return false;
          }
        });
      }

      // 修改信息状态
      if (this.isEdit) {
        delete this.rules.userName; // 编辑删除账号校验
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.modifyExamInfo();
          } else {
            console.log("check error edit!!");
            return false;
          }
        });
      }
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 添加考生数据 this.$moment(item.UpdateTime).format("YYYY-MM-DD"); this.ExamForm.Birthday;
    async addExamData() {
      this.UtilFun(this.examAddObj);
      this.examAddObj.userName = this.ExamForm.userName;
      this.examAddObj.realName = this.ExamForm.realName;
      this.examAddObj.password = md5Utils(this.ExamForm.pwd);
      if (this.ExamForm.JoinDate) {
        this.examAddObj.JobDate = this.$moment(this.ExamForm.JoinDate).format(
          "YYYY-MM-DD"
        );
      }
      if (this.ExamForm.Birthday) {
        this.examAddObj.Birthday = this.$moment(this.ExamForm.Birthday).format(
          "YYYY-MM-DD"
        );
      }
      this.examAddObj.departmentName = this.ExamForm.DepartmentName;
      this.examAddObj.PTitle = !this.ExamForm.PTitle ?'':this.ExamForm.PTitle ;
      this.examAddObj.Position = this.ExamForm.Position ? this.ExamForm.Position:'';
      const { data } = await createStudent(this.examAddObj);
      if (data.Status === 200) {
        console.log(data, "添加考生");
        // 发送消息
        this.$emit("success");
        // 设置成功提示
        this.$message.success("添加成功");
        // 清除表单内容
        this.$refs.ExamForm.resetFields();
        this.ExamForm = {};
      } else {
        this.$message.error(data.Data);
      }
    },

    // 获取科室数据
    async getSectionData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getSectionList(sectionObj);
      if (data.Status === 200) {
        // console.log(data, "科室下拉列表数据");
        this.options_ks = data.Data;
      }
    },
    // 获取职称数据
    async getPTitleData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getPTitleList(sectionObj);
      if (data.Status === 200) {
        // console.log(data, "职称数据");
        this.options_zc = data.Data;
        this.options_zc = this.options_zc.forEach((element, index) => {
          element.pTitleID = index;
        });
        this.options_zc = data.Data;
      }
    },
    // 获取职位数据
    async getPositionData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getPositionList(sectionObj);
      if (data.Status === 200) {
        // console.log(data, "职位数据");
        this.options_zw = data.Data;
        this.options_zw = this.options_zw.forEach((element, index) => {
          element.PositionID = index;
        });
        this.options_zw = data.Data;
      }
    },

    // 确定修改考生信息
    async modifyExamInfo() {
      const examInfo = {};
      this.UtilFun(examInfo);
      // 考生ID
      examInfo.UpdataID = this.$parent.$parent.editData[6];
      // 真实名称
      examInfo.realName = this.ExamForm.realName;
      // 科室
      console.log("科室 ========>> " + this.ExamForm.DepartmentName);
      examInfo.departmentName = this.ExamForm.DepartmentName;
      // 职称
      console.log("职称 ========>> " + this.ExamForm.PTitle);
      examInfo.PTitle = this.ExamForm.PTitle;
      // 职位
      console.log("职位 ========>> " + this.ExamForm.Position);
      examInfo.Position = this.ExamForm.Position;
      // 入职日期
      if (this.ExamForm.JoinDate) {
        examInfo.JobDate = this.$moment(this.ExamForm.JoinDate).format(
          "YYYY-MM-DD"
        );
      }
      // 生日
      if (this.ExamForm.Birthday) {
        examInfo.Birthday = this.$moment(this.ExamForm.Birthday).format(
          "YYYY-MM-DD"
        );
      }
      console.log(examInfo);
      const { data } = await modifyStudentInfo(examInfo);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("修改考生信息成功");
        // 发送消息
        this.$emit("success");
        // 清除表单内容
        this.$refs.ExamForm.resetFields();
        this.ExamForm = {};
      } else {
        this.$message.error(data.Data);
      }
    },

    // 编辑数据
    editDataShow() {
      console.log(this.$parent.$parent.editData);
      this.ExamForm.userName = this.$parent.$parent.editData[0];
      this.ExamForm.realName = this.$parent.$parent.editData[1];
      this.ExamForm.DepartmentName = this.$parent.$parent.editData[2];
      this.ExamForm.PTitle = this.$parent.$parent.editData[3];
      this.ExamForm.Position = this.$parent.$parent.editData[4];
      this.ExamForm.Birthday = this.$parent.$parent.editData[5];
      this.ExamForm.JoinDate = this.$parent.$parent.editData[7];
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.options_zc.map((item) => {
        return { value: item.PTitle, id: item.PTitle };
      });
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    querySearchAsyncTwo(queryString, cb) {
      var restaurants = this.options_zw.map((item) => {
        return { value: item.Position, id: item.Position };
      });
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    handleSelectTwo(item) {
      this.ExamForm.Position = item.value;
    },
    //点击出现搜索后点击的每一项
    handleSelect(item) {
      this.ExamForm.PTitle = item.value;
    },
  },
  created() {
    this.getSectionData();
    this.getPTitleData();
    this.getPositionData();
    // 弹框编辑数据
    this.editDataShow();
  },
  mounted() {},
};
</script>

<style lang='scss' scoped>
.el-form {
  display: flex;
  flex-direction: column;
}

.dialog-footer {
  text-align: center;
  margin-top: 50px;
  .el-button {
    margin-right: 30px;
    &:nth-child(1) {
      background: #eeeeee;
      opacity: 1;
      border-radius: 4px;
    }
    &:nth-child(2) {
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
</style>
